import SubscriptionView from './SubscriptionView';

export default class AccountView {
    constructor(json) {
        this.id = json.id;
        this.name = json.name;
        this.favicon = json.favicon ?? '';
        this.logo = json.logo ?? '';
        this.squaredLogo = json.squaredLogo ?? '';
        this.applicationTitle = json.applicationTitle ?? '';
        this.anonymization = json.anonymization ?? 'all_anonymous';
        this.otherBooking = json.otherBooking;
        this.allowParallelBooking = json.allowParallelBooking;
        this.bookingAdminListAnonymization = json.bookingAdminListAnonymization;
        this.maxBookingDays = json.maxBookingDays;
        this.locale = (json.locale ?? '').toLowerCase();
        this.allowSeats = json.allowSeats;
        this.allowZones = json.allowZones;
        this.allowMeetingRooms = json.allowMeetingRooms;
        this.allowParkingSpaces = json.allowParkingSpaces;
        this.authorizationGroups = json.authorizationGroups;
        this.allowAvatar = json.allowAvatar;
        this.allowGravatar = json.allowGravatar;
        this.checkinRequired = json.checkinRequired;
        this.checkinOnlyViaConnect = json.checkinOnlyViaConnect ?? false;
        if (json.subscription) {
            this.subscription = new SubscriptionView(json.subscription);
        }
        this.komboADIntegration = json.komboADIntegration;
        this.komboHRIntegration = json.komboHRIntegration;
        this.isKomboPhotosScope = json.isKomboPhotosScope;
        this.komboIntegrations = this.komboADIntegration || this.komboHRIntegration;
        this.useKomboAvatar = json.useKomboAvatar;
        this.isMeetingRoomSync = json.isMeetingRoomSync;
        this.managersDeletingSeatingElements = json.managersDeletingSeatingElements;
        this.anonymiseBookingsForRoles = json.anonymiseBookingsForRoles || [];
        this.bookingDataAnonymization = json.bookingDataAnonymization ?? true;
        this.bookingDataRetentionDays = json.bookingDataRetentionDays ?? 90;
        this.costCenterFileName = json.costCenterFileName;
        this.costCenterUploadedAt = json.costCenterUploadedAt;
        this.costCenterCount = json.costCenterCount;
        this.costCenterEnabled = json.costCenterEnabled;
        this.guestBookings = json.guestBookings ?? false;
        this.guestBookingDataRetentionDays = json.guestBookingDataRetentionDays ?? null;
        this.guestBookingPrivacyPolicyUrl = json.guestBookingPrivacyPolicyUrl ?? '';
        this.guestBookingActivationConfirmed = json.guestBookingActivationConfirmed ?? false;
        // TODO(BE): the account view does not return optionalGuestEmail and optionalGuestEmailConfirmed yet.
        this.optionalGuestEmail = json.optionalGuestEmail ?? false;
        this.optionalGuestEmailConfirmed = json.optionalGuestEmailConfirmed ?? false;
    }

    get anonymous() {
        return this.anonymization === 'all_anonymous';
    }

    get userAnonymization() {
        return (
            this.anonymization === 'anonymous_by_default' ||
            this.anonymization === 'visible_by_default'
        );
    }
}
